export enum SortDirection {
    Ascending = 0,
    Descending = 1,
}

export enum MatSortDirection {
    Ascending = 'asc',
    Descending = 'desc',
}
